import * as Yup from 'yup';

export const DispatcherAssignSchema = Yup.object().shape({
  dispatcher: Yup.string().min(1).required('Dispatcher is required'),
});

export type DispatcherAssignDataType = Yup.InferType<
  typeof DispatcherAssignSchema
>;

type InitialValues = {
  dispatcher: string;
};

export const DispatcherAssignInitialValues: InitialValues = {
  dispatcher: '',
};

export interface IDispatcherAssignResponse {}

export interface IDispatcherAssignRequest {
  // dispatcher: string;
  dispatcherId: string;
  picklistId: string;
}
